import React from 'react';
import '../styles/EmailViewer.css';
import DescriptionPanel from './DescriptionPanel';
import EmailPanel from './EmailPanel';
import InboxSection from './InboxSection';
import { EmailProvider } from '../contexts/EmailContext';
import SocialMetaTags from './SocialMetaTags';
import { Helmet } from 'react-helmet';
import NativeBannerAd from './NativeBannerAd';
import { useCountry } from './CountryContext';

const EmailViewerContent = () => {
    const { code } = useCountry();
    
    return (
        <div className="container">
            <div className="top-section">
                <DescriptionPanel country={code} />
                <EmailPanel country={code} />
            </div>
            <NativeBannerAd country={code} />
            <InboxSection country={code} />
        </div>
    );
};

const EmailViewer = () => {
    const { code, name, language } = useCountry();
    
    return (
        <EmailProvider>
            <Helmet>
                <title>{`Quick Inbox ${name} - Free Temp Mail & Temporary Email Service`}</title>
                <meta name="description" content={`Create free disposable email addresses in ${name}. Get temporary email instantly to protect your privacy and avoid spam. No registration required.`} />
                <meta name="keywords" content={`temp mail ${name}, temporary email ${name}, disposable email ${name}, fake email, anonymous email, temp mailbox`} />
                <link rel="canonical" href={`https://quick-inbox.com/${code}`} />
                <html lang={language} />
            </Helmet>
            <SocialMetaTags
                title={`Quick Inbox ${name} - Free Temporary Email Service`}
                description={`Create free disposable email addresses in ${name}. Protect your privacy and avoid spam with temporary emails.`}
                url={`https://quick-inbox.com/${code}`}
                image="https://quick-inbox.com/images/temp-mail-service.jpg"
            />
            <EmailViewerContent />
        </EmailProvider>
    );
};

export default EmailViewer; 